<template>
  <div>
    <FrontendServiceOverview />
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'iframe' })
const { autoSearch, requireLocationOrSupportNeedForAutoSearch } = storeToRefs(useServiceSearchStore())

onMounted(() => {
  autoSearch.value = true
  requireLocationOrSupportNeedForAutoSearch.value = false
  useServiceSearchStore().search()
})
</script>
